export class Timezones {
  static DEFAULT_TIMEZONE = 'Europe/Berlin';
}
